import { sc } from '@/utils/storage'
import { INSIDE_APPID } from '@/utils/storage-const'
import { bindChannel } from '@/services/module/videoClip'
import { userInfo } from '@/services/module/user'

let hasShownPcChannelBoundMessage = false

function normalizeCode(code) {
  if (Array.isArray(code)) return normalizeCode(code[0])
  if (code === undefined || code === null) return ''
  return `${code}`.trim()
}

async function refreshUserPromoteCode(store, fallbackCode = '') {
  const {
    data: { data, code }
  } = await userInfo({}, false)
  if (code != 0) {
    await store.dispatch('user/clearToken', false)
    await store.dispatch('channelAttributionChange', {})
    return ''
  }

  await store.dispatch('user/updateUserInfo', data)
  if (data?.token) {
    await store.dispatch('user/updateToken', data.token)
  }

  const promoteCode = normalizeCode(data?.promote_code || data?.promoteCode) || fallbackCode
  await store.dispatch('channelAttributionChange', { promoteCode })
  return promoteCode
}

export async function resolvePcChannelPromote({ route, store, message }) {
  const routePromoteCode = normalizeCode(route?.query?.promote_code)
  const isHome = route?.name === 'Home' || route?.path === '/'
  if (!isHome || !routePromoteCode) return

  if (!store?.state?.user?.token) {
    await store.dispatch('channelAttributionChange', { promoteCode: routePromoteCode })
    return
  }

  if (!store.state.user.info) {
    await refreshUserPromoteCode(store)
    if (!store.state.user.token) {
      await store.dispatch('channelAttributionChange', { promoteCode: routePromoteCode })
      return
    }
  }

  const userInfo = store.state.user.info
  const userPromoteCode = normalizeCode(userInfo?.promote_code || userInfo?.promoteCode)
  if (userPromoteCode) {
    await store.dispatch('channelAttributionChange', { promoteCode: userPromoteCode })
    if (!hasShownPcChannelBoundMessage) {
      hasShownPcChannelBoundMessage = true
      message?.warning?.('当前用户已绑定渠道商，无需重复绑定')
    }
    return
  }

  try {
    const {
      data: { code, errMsg, msg }
    } = await bindChannel({ promote_code: routePromoteCode })
    if (code != 0) {
      message?.error?.(errMsg || msg || '绑定渠道码失败')
      await store.dispatch('channelAttributionChange', {})
      return
    }
    await refreshUserPromoteCode(store, routePromoteCode)
  } catch (e) {
    message?.error?.(e?.errMsg || e?.message || '绑定渠道码失败')
    await store.dispatch('channelAttributionChange', {})
  }
}

export function checkMiniEnv(to) {
  try {
    const currentRoute = to
    const { query } = currentRoute
    const insideAppId = query?.insideAppId
    if (insideAppId) {
      sc(INSIDE_APPID, insideAppId)
    }
  } catch (e) {
    console.log(e)
  }
}
import { mapState } from 'vuex'
export const homeLeftRightBtnMixins = {
  computed: {
    ...mapState({
      userInfo: (state) => state.user.info
    }),
    rightBtnFont() {
      if (this.userInfo) return '申请进度'
      return 'KOL入驻'
    }
  },
  methods: {
    rightBtnClick() {
      this.$emit('rightBtnClick')
    }
  }
}
